import React from 'react';
import { isLoggedIn, login } from './AuthenticationService';
import FullScreenLoadingComponent from '../Components/Loaders/FullScreenLoadingComponent';

export const PrivateRoute = (Component, isAdmin) => props =>
  isLoggedIn() ? (
    <Component {...props} isAdmin={isAdmin} />
  ) : (
    <React.Fragment>
      <FullScreenLoadingComponent />
      {login(props.location)}
    </React.Fragment>
  );



// WEBPACK FOOTER //
// ./src/Authentication/PrivateRoute.js